export const laoHotelWorkspace: Record<string, string> = {
  Reservation: 'ການຈອງ',
  'Add the guest and stay details. Review the total before saving.':
    'ປ້ອນຂໍ້ມູນແຂກ ແລະ ການເຂົ້າພັກ. ກວດສອບຍອດລວມກ່ອນບັນທຶກ.',
  'Book one room or add additional rooms for the same stay.':
    'ຈອງໜຶ່ງຫ້ອງ ຫຼື ເພີ່ມຫ້ອງສຳລັບການເຂົ້າພັກດຽວກັນ.',
  'Booking summary': 'ສະຫຼຸບການຈອງ',
  'Fewer guests': 'ຫຼຸດຈຳນວນແຂກ',
  'More guests': 'ເພີ່ມຈຳນວນແຂກ',
  'More options': 'ຕົວເລືອກເພີ່ມເຕີມ',
  'Guest group, companions, notes': 'ກຸ່ມແຂກ, ຜູ້ຮ່ວມພັກ, ໝາຍເຫດ',
  'Rate & booking': 'ລາຄາ ແລະ ການຈອງ',
  'Full name': 'ຊື່ ແລະ ນາມສະກຸນ',
  'Not entered': 'ຍັງບໍ່ໄດ້ປ້ອນ',
  'Room charges only. Payments are recorded after creation.':
    'ສະເພາະຄ່າຫ້ອງ. ບັນທຶກການຊຳລະຫຼັງຈາກສ້າງການຈອງ.',
  'You do not have permission to create this entry.': 'ທ່ານບໍ່ມີສິດສ້າງລາຍການນີ້.',
  'Enter a reason to continue.': 'ປ້ອນເຫດຜົນເພື່ອດຳເນີນການຕໍ່.',
  'Choose today or a future start date.': 'ເລືອກວັນເລີ່ມເປັນມື້ນີ້ ຫຼື ວັນໃນອະນາຄົດ.',
  'Enter the guest name to continue.': 'ປ້ອນຊື່ແຂກເພື່ອດຳເນີນການຕໍ່.',
  'Enter a reason for the past-dated reservation.': 'ປ້ອນເຫດຜົນສຳລັບການຈອງຍ້ອນຫຼັງ.',
  'Review the rate plan restrictions to continue.': 'ກວດສອບຂໍ້ຈຳກັດຂອງແຜນລາຄາເພື່ອດຳເນີນການຕໍ່.',
  'Checking…': 'ກຳລັງກວດສອບ…',
  selected: 'ເລືອກແລ້ວ',
  'Your groups': 'ກຸ່ມແຂກຂອງທ່ານ',
  'Choose a group to view its stays, or select reservations below to create one.':
    'ເລືອກກຸ່ມເພື່ອເບິ່ງການເຂົ້າພັກ ຫຼື ເລືອກການຈອງດ້ານລຸ່ມເພື່ອສ້າງກຸ່ມໃໝ່.',
  'Find a group…': 'ຄົ້ນຫາກຸ່ມແຂກ…',
  'active reservations': 'ການຈອງທີ່ຍັງໃຊ້ງານ',
  'Viewing group': 'ກຳລັງເບິ່ງກຸ່ມນີ້',
  'View stays & history': 'ເບິ່ງການເຂົ້າພັກ ແລະ ປະຫວັດ',
  'No groups match your search.': 'ບໍ່ພົບກຸ່ມທີ່ກົງກັບການຄົ້ນຫາ.',
  'Add existing stays': 'ເພີ່ມການຈອງທີ່ມີແລ້ວ',
  'Select reservations to add to': 'ເລືອກການຈອງເພື່ອເພີ່ມໃສ່',
  'Select active reservations to create, move or remove a group.':
    'ເລືອກການຈອງທີ່ຍັງໃຊ້ງານ ເພື່ອສ້າງກຸ່ມ, ຍ້າຍກຸ່ມ ຫຼື ເອົາອອກຈາກກຸ່ມ.',
  'Remove group filter': 'ເອົາຕົວກອງກຸ່ມອອກ',
  'Export this view': 'ສົ່ງອອກລາຍການນີ້',
  'Add to group': 'ເພີ່ມໃສ່ກຸ່ມ',
  'Clear filters to see more stays, or add a reservation to this group.':
    'ລ້າງຕົວກອງເພື່ອເບິ່ງການຈອງເພີ່ມ ຫຼື ເພີ່ມການຈອງໃສ່ກຸ່ມນີ້.',
  'This reservation has no linked guest profile.': 'ການຈອງນີ້ບໍ່ມີຂໍ້ມູນແຂກທີ່ເຊື່ອມໂຍງ.',
  Folio: 'ໃບບັນຊີ',
  Notes: 'ໝາຍເຫດ',
  Activity: 'ກິດຈະກຳ',
  'Stay overview': 'ສະຫຼຸບການພັກ',
  'Swipe to switch sections': 'ປັດເພື່ອປ່ຽນພາກ',
  'Activity date': 'ວັນທີກິດຈະກຳ',
  'Activity views use this date.': 'ມຸມມອງກິດຈະກຳໃຊ້ວັນທີນີ້.',
  'Linked guest history': 'ປະຫວັດແຂກທີ່ເຊື່ອມໂຍງ',
  'Use Clear filters to return to all guests.': 'ກົດລ້າງຕົວກອງເພື່ອກັບໄປເບິ່ງແຂກທັງໝົດ.',
  'View complete guest history': 'ເບິ່ງປະຫວັດແຂກທັງໝົດ',
  'Open latest record in a new tab': 'ເປີດລາຍການຫຼ້າສຸດໃນແຖບໃໝ່',
  'Compare your entries before closing and reopening this form.':
    'ປຽບທຽບຂໍ້ມູນທີ່ປ້ອນກ່ອນປິດ ແລະ ເປີດແບບຟອມໃໝ່.',
  'Daily operations': 'ວຽກປະຈຳວັນ',
  'Guests & revenue': 'ແຂກ ແລະ ລາຍຮັບ',
  Administration: 'ການບໍລິຫານ',
  'Search hotel guests and reservations across all dates.': 'ຄົ້ນຫາແຂກ ແລະ ການຈອງໂຮງແຮມໃນທຸກວັນທີ.',
  'This property · all dates': 'ໂຮງແຮມນີ້ · ທຸກວັນທີ',
  'Searching…': 'ກຳລັງຄົ້ນຫາ…',
  'View all matching reservations': 'ເບິ່ງການຈອງທີ່ກົງທັງໝົດ',
  'View guest profiles': 'ເບິ່ງຂໍ້ມູນແຂກ',
  'No hotel records found. Try a guest name, phone, email or reservation number.':
    'ບໍ່ພົບຂໍ້ມູນໂຮງແຮມ. ລອງຊື່ແຂກ, ເບີໂທ, ອີເມວ ຫຼື ເລກການຈອງ.',
  'Front desk options': 'ຕົວເລືອກໜ້າເຄົາເຕີ',
  'Front desk date': 'ວັນທີໜ້າເຄົາເຕີ',
  'Open room calendar': 'ເປີດປະຕິທິນຫ້ອງ',
  'sellable rooms': 'ຫ້ອງທີ່ຂາຍໄດ້',
  'Planned, not collected': 'ຕາມແຜນ, ຍັງບໍ່ແມ່ນເງິນທີ່ຮັບແລ້ວ',
  Stayovers: 'ແຂກພັກຕໍ່',
  'Shift activity': 'ວຽກໃນກະ',
  'Include completed': 'ລວມລາຍການທີ່ສຳເລັດແລ້ວ',
  'Review check-in': 'ກວດກ່ອນເຊັກອິນ',
  'Review checkout': 'ກວດກ່ອນເຊັກເອົາ',
  'No reservations need action in this view.': 'ບໍ່ມີການຈອງທີ່ຕ້ອງດຳເນີນການໃນມຸມມອງນີ້.',
  'Room readiness and sellable availability are separate measures.':
    'ຄວາມພ້ອມຂອງຫ້ອງ ແລະ ຫ້ອງຫວ່າງທີ່ຂາຍໄດ້ແມ່ນຄົນລະຕົວຊີ້ວັດ.',
  'View forecast & insights': 'ເບິ່ງການຄາດຄະເນ ແລະ ພາບລວມ',
  'Arrival overdue': 'ເລີຍວັນເຂົ້າພັກ',
  'Departure overdue': 'ເລີຍວັນອອກ',
  'Confirmation required': 'ຕ້ອງຢືນຢັນ',
  'Room needs attention': 'ຫ້ອງຕ້ອງການກວດກາ',
  'Payment required': 'ຕ້ອງຊຳລະເງິນ',
  'Search dates': 'ຂອບເຂດວັນທີ',
  'Filters & export': 'ຕົວກອງ ແລະ ສົ່ງອອກ',
  'Export 14-day guests': 'ສົ່ງອອກແຂກໃນຊ່ວງ 14 ວັນ',
  'All dates · full history': 'ທຸກວັນທີ · ປະຫວັດທັງໝົດ',
  'Selected 14-day window': 'ຊ່ວງ 14 ວັນທີ່ເລືອກ',
  'Past and future reservations': 'ການຈອງທີ່ຜ່ານມາ ແລະ ໃນອະນາຄົດ',
  'Search guest, contact or reservation…': 'ຄົ້ນຫາແຂກ, ຂໍ້ມູນຕິດຕໍ່ ຫຼື ການຈອງ…',
  'Calendar reservation status': 'ສະຖານະການຈອງໃນປະຕິທິນ',
  'Calendar booking source': 'ແຫຼ່ງການຈອງໃນປະຕິທິນ',
  'All reservation statuses': 'ທຸກສະຖານະການຈອງ',
  'All booking sources': 'ທຸກແຫຼ່ງການຈອງ',
  "Today's activity": 'ການເຂົ້າພັກ ແລະ ອອກໃນມື້ນີ້',
  "Today's arrivals": 'ເຂົ້າພັກມື້ນີ້',
  "Today's departures": 'ອອກມື້ນີ້',
  "Today's arrivals and departures": 'ເຂົ້າພັກ ແລະ ອອກມື້ນີ້',
  'Room details': 'ລາຍລະອຽດຫ້ອງ',
  'Stays in this date window': 'ການເຂົ້າພັກໃນຊ່ວງວັນທີນີ້',
  'Choose a rate plan': 'ເລືອກແຜນລາຄາ',
  'Choose the exact plan before changing prices or restrictions.':
    'ເລືອກແຜນລາຄາທີ່ຈະແກ້ໄຂກ່ອນປ່ຽນລາຄາ ຫຼື ຂໍ້ຈຳກັດ.',
  'No active rate plans for this room type': 'ບໍ່ມີແຜນລາຄາທີ່ໃຊ້ງານສຳລັບຫ້ອງປະເພດນີ້',
  'Review rate change': 'ກວດການປ່ຽນລາຄາ',
  dates: 'ວັນທີ',
  'Full reservation': 'ການຈອງແບບເຕັມ',
  'Quick view': 'ມຸມມອງດ່ວນ',
  'Guest details saved with this stay': 'ຂໍ້ມູນແຂກທີ່ບັນທຶກກັບການເຂົ້າພັກນີ້',
  'Profile changes do not rewrite the guest details saved with this reservation.':
    'ການປ່ຽນຂໍ້ມູນແຂກບໍ່ປ່ຽນຂໍ້ມູນທີ່ບັນທຶກກັບການຈອງນີ້.',
  'Linked guest profile': 'ຂໍ້ມູນແຂກທີ່ເຊື່ອມໂຍງ',
  'No profile linked. Select a profile when editing an eligible reservation.':
    'ຍັງບໍ່ເຊື່ອມຂໍ້ມູນແຂກ. ເລືອກຂໍ້ມູນແຂກເມື່ອແກ້ໄຂການຈອງທີ່ແກ້ໄຂໄດ້.',
  'View profile & stay history': 'ເບິ່ງຂໍ້ມູນແຂກ ແລະ ປະຫວັດເຂົ້າພັກ',
  'Offline · showing saved data': 'ອອບລາຍ · ສະແດງຂໍ້ມູນທີ່ໂຫຼດແລ້ວ',
  'Update failed · showing saved data': 'ອັບເດດບໍ່ສຳເລັດ · ສະແດງຂໍ້ມູນທີ່ໂຫຼດແລ້ວ',
  'Updating…': 'ກຳລັງອັບເດດ…',
  Updated: 'ອັບເດດແລ້ວ',
  'Refresh to check for changes': 'ໂຫຼດໃໝ່ເພື່ອກວດການປ່ຽນແປງ',
  'Refresh hotel data': 'ໂຫຼດຂໍ້ມູນໂຮງແຮມໃໝ່',
  'Your entries have been kept. Review the latest record before trying again.':
    'ຂໍ້ມູນທີ່ທ່ານປ້ອນຍັງຢູ່. ກວດລາຍການຫຼ້າສຸດກ່ອນລອງອີກຄັ້ງ.',
  // Running folios, direct billing, reinstatement and after-midnight arrivals (2026-10-08)
  'This stay is invoiced. Added nights or charges are billed on a supplementary invoice; reducing billed nights needs the invoice voided or credited.':
    'ການພັກນີ້ອອກໃບແຈ້ງໜີ້ແລ້ວ. ຄືນ ຫຼື ຄ່າບໍລິການທີ່ເພີ່ມຈະອອກໃບແຈ້ງໜີ້ເພີ່ມເຕີມ; ການຫຼຸດຄືນທີ່ອອກໃບແຈ້ງໜີ້ແລ້ວຕ້ອງຍົກເລີກ ຫຼື ຫຼຸດໜີ້ໃບແຈ້ງໜີ້ນັ້ນກ່ອນ.',
  'Add fee or late charge': 'ເພີ່ມຄ່າທຳນຽມ ຫຼື ຄ່າບໍລິການຍ້ອນຫຼັງ',
  'Released · only billed nights remain': 'ປ່ອຍຫ້ອງແລ້ວ · ເຫຼືອແຕ່ຄືນທີ່ອອກໃບແຈ້ງໜີ້ແລ້ວ',
  Billed: 'ອອກໃບແຈ້ງໜີ້ແລ້ວ',
  'Not yet invoiced': 'ຍັງບໍ່ອອກໃບແຈ້ງໜີ້',
  'Bill these on a supplementary invoice before checkout':
    'ອອກໃບແຈ້ງໜີ້ເພີ່ມເຕີມສຳລັບລາຍການເຫຼົ່ານີ້ກ່ອນອອກຈາກຫ້ອງ',
  'Invoice unbilled items': 'ອອກໃບແຈ້ງໜີ້ລາຍການທີ່ຍັງບໍ່ອອກ',
  'Bill to this customer': 'ອອກໃບແຈ້ງໜີ້ໃຫ້ລູກຄ້ານີ້',
  'Everything unbilled': 'ທຸກລາຍການທີ່ຍັງບໍ່ອອກໃບແຈ້ງໜີ້',
  'Room only': 'ຄ່າຫ້ອງເທົ່ານັ້ນ',
  'Extra charges only': 'ຄ່າບໍລິການເພີ່ມເທົ່ານັ້ນ',
  'Bill the unbilled charges and nights before checkout.':
    'ອອກໃບແຈ້ງໜີ້ຄ່າບໍລິການ ແລະ ຄືນທີ່ຍັງບໍ່ອອກ ກ່ອນອອກຈາກຫ້ອງ.',
  'Settle the balance, or use direct bill checkout for a company account.':
    'ຊຳລະຍອດຄ້າງ, ຫຼື ໃຊ້ການອອກຈາກຫ້ອງແບບເກັບເງິນຈາກບໍລິສັດ.',
  'Direct bill checkout': 'ອອກຈາກຫ້ອງ · ເກັບເງິນຈາກບໍລິສັດ',
  "Check the guest out and leave the posted balance on the billing company's account in accounts receivable. Collect it later through LFB receipts.":
    'ບັນທຶກແຂກອອກຈາກຫ້ອງ ແລະ ໃຫ້ຍອດຄ້າງທີ່ບັນທຶກແລ້ວຢູ່ໃນບັນຊີລູກໜີ້ຂອງບໍລິສັດ. ເກັບເງິນພາຍຫຼັງດ້ວຍໃບຮັບເງິນ LFB.',
  'Company account and payment terms': 'ບັນຊີບໍລິສັດ ແລະ ເງື່ອນໄຂການຊຳລະ',
  'Check out to company account': 'ອອກຈາກຫ້ອງ ແລະ ໂອນຍອດໄປບັນຊີບໍລິສັດ',
  'Guest checked out · direct bill': 'ແຂກອອກຈາກຫ້ອງແລ້ວ · ເກັບເງິນຈາກບໍລິສັດ',
  'Balance to company account': 'ຍອດທີ່ໂອນໄປບັນຊີບໍລິສັດ',
  'Direct bill · the balance is collected from the company account in LFB receipts.':
    'ເກັບເງິນຈາກບໍລິສັດ · ຍອດຄ້າງຈະເກັບຈາກບັນຊີບໍລິສັດດ້ວຍໃບຮັບເງິນ LFB.',
  'Reinstate reservation': 'ກູ້ຄືນການຈອງ',
  'Return this booking to Confirmed. Every room night is checked again; if a room was resold, move or rebook instead.':
    'ປ່ຽນການຈອງນີ້ກັບເປັນຢືນຢັນແລ້ວ. ລະບົບຈະກວດທຸກຄືນອີກຄັ້ງ; ຖ້າຫ້ອງຖືກຂາຍໃຫ້ຄົນອື່ນແລ້ວ ໃຫ້ຍ້າຍຫ້ອງ ຫຼື ຈອງໃໝ່.',
  'Reinstatement reason': 'ເຫດຜົນການກູ້ຄືນ',
  'Reservation reinstated': 'ກູ້ຄືນການຈອງແລ້ວ',
  'After-midnight arrival for last night, before the late-arrival cutoff':
    'ມາຮອດຫຼັງທ່ຽງຄືນ ສຳລັບຄືນທີ່ຜ່ານມາ, ກ່ອນເວລາປິດຮັບແຂກມາຊ້າ',
  'After-midnight arrival: this books last night, which is still open until':
    'ມາຮອດຫຼັງທ່ຽງຄືນ: ການຈອງນີ້ແມ່ນສຳລັບຄືນທີ່ຜ່ານມາ ເຊິ່ງຍັງເປີດຮັບຈົນຮອດ',
  'Reason for a past-dated reservation': 'ເຫດຜົນຂອງການຈອງຍ້ອນຫຼັງ',
  'Recorded in the activity history. Days already closed cannot be booked.':
    'ບັນທຶກໄວ້ໃນປະຫວັດ. ບໍ່ສາມາດຈອງວັນທີ່ປິດມື້ແລ້ວ.',
  'Late-arrival cutoff': 'ເວລາປິດຮັບແຂກມາຊ້າ',
  'Until this time, a guest arriving after midnight books and checks in for last night. 00:00 turns it off.':
    'ກ່ອນເວລານີ້ ແຂກທີ່ມາຮອດຫຼັງທ່ຽງຄືນຈະຈອງ ແລະ ເຂົ້າພັກສຳລັບຄືນທີ່ຜ່ານມາ. 00:00 ແມ່ນປິດການນຳໃຊ້.',
  'Enter a reason for a reservation that starts in the past':
    'ປ້ອນເຫດຜົນສຳລັບການຈອງທີ່ເລີ່ມໃນອະດີດ',
  'A daily close already reported this date. Book from today instead.':
    'ວັນນີ້ປິດມື້ແລ້ວ. ກະລຸນາຈອງເລີ່ມແຕ່ມື້ນີ້.',
  'Bill the unbilled charges and nights on an LFB invoice before checkout':
    'ອອກໃບແຈ້ງໜີ້ LFB ສຳລັບຄ່າບໍລິການ ແລະ ຄືນທີ່ຍັງບໍ່ອອກ ກ່ອນອອກຈາກຫ້ອງ',
  'Post every invoice to the company account before a direct-bill checkout':
    'ບັນທຶກທຸກໃບແຈ້ງໜີ້ໃຫ້ບັນຊີບໍລິສັດ ກ່ອນອອກຈາກຫ້ອງແບບເກັບເງິນຈາກບໍລິສັດ',
  'Only a cancelled or no-show reservation can be reinstated':
    'ກູ້ຄືນໄດ້ສະເພາະການຈອງທີ່ຍົກເລີກ ຫຼື ບໍ່ມາເຂົ້າພັກ',
  'This stay has already ended. Create a new reservation instead.':
    'ການພັກນີ້ສິ້ນສຸດແລ້ວ. ກະລຸນາສ້າງການຈອງໃໝ່.',
  'A daily close already reported this arrival. Create a new reservation for the actual dates.':
    'ການມາຮອດນີ້ຖືກລາຍງານໃນການປິດມື້ແລ້ວ. ກະລຸນາສ້າງການຈອງໃໝ່ຕາມວັນທີແທ້.',
  'This change takes the stay below the billed amount. Void or credit the linked invoice first.':
    'ການປ່ຽນແປງນີ້ເຮັດໃຫ້ຍອດຕ່ຳກວ່າທີ່ອອກໃບແຈ້ງໜີ້ແລ້ວ. ຍົກເລີກ ຫຼື ຫຼຸດໜີ້ໃບແຈ້ງໜີ້ກ່ອນ.',
  'Direct billing applies to checkout only': 'ການເກັບເງິນຈາກບໍລິສັດໃຊ້ໄດ້ສະເພາະຕອນອອກຈາກຫ້ອງ',
  'Enter the company account and terms for a direct-bill checkout':
    'ປ້ອນບັນຊີບໍລິສັດ ແລະ ເງື່ອນໄຂ ສຳລັບການອອກຈາກຫ້ອງແບບເກັບເງິນຈາກບໍລິສັດ',
  'Part 2': 'ສ່ວນທີ 2',
  'Guest group created': 'ສ້າງກຸ່ມແຂກແລ້ວ',
  'Group split': 'ແຍກກຸ່ມແລ້ວ',
  'New guest group': 'ກຸ່ມແຂກໃໝ່',
  'Add stays to': 'ເພີ່ມການເຂົ້າພັກໃສ່',
  Split: 'ແຍກ',
  'Choose the stays that move to a new group. The rest stay where they are.':
    'ເລືອກການເຂົ້າພັກທີ່ຈະຍ້າຍໄປກຸ່ມໃໝ່. ສ່ວນທີ່ເຫຼືອຍັງຢູ່ກຸ່ມເດີມ.',
  'Pick guests or whole rooms. Names, rooms and folios stay separate.':
    'ເລືອກແຂກ ຫຼື ທັງຫ້ອງ. ຊື່, ຫ້ອງ ແລະ ໃບບັນຊີ ຍັງແຍກກັນຄືເກົ່າ.',
  'Create group': 'ສ້າງກຸ່ມ',
  Add: 'ເພີ່ມ',
  'New group name': 'ຊື່ກຸ່ມໃໝ່',
  'Search guest, room or reservation…': 'ຄົ້ນຫາແຂກ, ຫ້ອງ ຫຼື ການຈອງ…',
  'Clear shown': 'ລ້າງທີ່ສະແດງ',
  'Select all shown': 'ເລືອກທັງໝົດທີ່ສະແດງ',
  'Select by room': 'ເລືອກຕາມຫ້ອງ',
  'No active stays match your search.': 'ບໍ່ພົບການເຂົ້າພັກທີ່ກົງກັບການຄົ້ນຫາ.',
  'No active stays to choose from.': 'ບໍ່ມີການເຂົ້າພັກທີ່ຍັງໃຊ້ງານໃຫ້ເລືອກ.',
  'Showing the first 100 stays. Search by guest or room to find more.':
    'ສະແດງ 100 ລາຍການທຳອິດ. ຄົ້ນຫາຕາມແຂກ ຫຼື ຫ້ອງ ເພື່ອເບິ່ງເພີ່ມ.',
  Rooms: 'ຫ້ອງ',
  Remove: 'ເອົາອອກ',
  'Nothing selected yet. Tick guests or tap a room number.':
    'ຍັງບໍ່ໄດ້ເລືອກ. ໝາຍແຂກ ຫຼື ກົດເລກຫ້ອງ.',
  'selected stays will leave their current group.': 'ການເຂົ້າພັກທີ່ເລືອກຈະອອກຈາກກຸ່ມປັດຈຸບັນ.',
  'Every stay is selected, so the whole group moves to the new name.':
    'ເລືອກທຸກການເຂົ້າພັກແລ້ວ, ທັງກຸ່ມຈະຍ້າຍໄປຊື່ໃໝ່.',
  'Choose a group to view its stays, or create one from guests and rooms.':
    'ເລືອກກຸ່ມເພື່ອເບິ່ງການເຂົ້າພັກ ຫຼື ສ້າງກຸ່ມໃໝ່ຈາກແຂກ ແລະ ຫ້ອງ.',
  'New group': 'ກຸ່ມໃໝ່',
  'Create a group': 'ສ້າງກຸ່ມ',
  'Pick guests or rooms in one step': 'ເລືອກແຂກ ຫຼື ຫ້ອງ ໃນຂັ້ນຕອນດຽວ',
  'Group a family, tour or company by picking their guests or rooms.':
    'ຈັດກຸ່ມຄອບຄົວ, ທົວ ຫຼື ບໍລິສັດ ໂດຍເລືອກແຂກ ຫຼື ຫ້ອງ.',
  'Tick stays to split them off, move them or remove them from this group.':
    'ໝາຍການເຂົ້າພັກເພື່ອແຍກອອກ, ຍ້າຍ ຫຼື ເອົາອອກຈາກກຸ່ມນີ້.',
  'Tick stays to group them, or use New group to pick guests and rooms.':
    'ໝາຍການເຂົ້າພັກເພື່ອຈັດກຸ່ມ ຫຼື ໃຊ້ ກຸ່ມໃໝ່ ເພື່ອເລືອກແຂກ ແລະ ຫ້ອງ.',
  'Add stays': 'ເພີ່ມການເຂົ້າພັກ',
  'A group needs at least two active stays to split.':
    'ກຸ່ມຕ້ອງມີການເຂົ້າພັກຢ່າງໜ້ອຍສອງລາຍການຈຶ່ງແຍກໄດ້.',
  'Split group': 'ແຍກກຸ່ມ',
  'Split into new group': 'ແຍກເປັນກຸ່ມໃໝ່',
  'New group from selection': 'ສ້າງກຸ່ມຈາກທີ່ເລືອກ',
  'Move or remove': 'ຍ້າຍ ຫຼື ເອົາອອກ',
};
